import React from "react";
import Typography from "@material-ui/core/Typography";
import TablaUbicaciones from "../components/TablaUbicaciones";
import useToken from "../useToken";
import { Redirect } from "react-router-dom";

class Ubicaciones extends React.Component{
    render() {
        const verifyFolio = useToken.verifyToken()

        if(!verifyFolio){
            return <Redirect to="/inventarios"/>
        }

        return(
            <div>
                <Typography variant="h4" gutterBottom>
                    Ubicaciones
                </Typography>
                <TablaUbicaciones/>
            </div>
        )
    }
}
export default Ubicaciones;